import React from "react";

const FloatingButtonPhone = () => {
  return (
    <>
      {/* whatsapp floating button */}
      <a className="btn-float-phone" href="tel:+91 90001 23670" target="_blank">
        {/* <i className="fab fa-whatsapp" /> */}
        <img
          src="/images/Footer/phone.svg"
          alt="WhatsApp"
          width="25"
          height="25"
        />
      </a>
    </>
  );
};

export default FloatingButtonPhone;
